import gql from 'graphql-tag';
export const StatFeatureShiftPlanner = gql `
    fragment StatFeatureShiftPlanner on ShiftPlannerFeatureSettingsFlags {
        isEnabled
        canOptIn
    }
`;
